import "./GlobalNetwork.module.css";
import GlobalNavigation from "@/reusable_sections/Header";
import RegionalLogisticsHubs from "./sections/RegionalLogisticsHubs";
import FleetSupportGallery from "./sections/FleetSupportGallery";
import Footer from "@/reusable_sections/Footer";
export default function GlobalNetworkPage() {
  return <div>
      <GlobalNavigation />
      <RegionalLogisticsHubs />
      <FleetSupportGallery />
      <Footer />
    </div>;
}